import { configureStore } from "@reduxjs/toolkit";
import { AuthApi } from "../utils/api/auth/auth.api";
import { UserSlice } from "./slice/User.slice";
import { UserApi } from "../utils/api/user/user.api";
import { currentEnv, Env } from "../utils/http";
import ConditionApi from "../utils/api/cgu/condition.api";
import BlanchisserieApi from "../utils/api/blanchisserie/blanchisserie.api";
import FaqApi from "../utils/api/faq/faq.api";
import TutoApi from "../utils/api/tuto/tuto.api";
import DesignationApi from "../utils/api/designation/designation.api";
import ProprietaireApi from "../utils/api/proprietaire/proprietaire.api";
import LogementApi from "../utils/api/logement/logement.api";
import PromotionApi from "../utils/api/promotion/promotion.api";
import PrestataireApi from "../utils/api/prestataire/prestataire.api";
import { MessagerieApi } from "../utils/api/messagerie/messagerie.api";
import ParrainageApi from "../utils/api/parrainage/parrainage.api";
import MissionApi from "../utils/api/mission/mission.api";
import DashboardApi from "../utils/api/dashboard/dashboard.api";
import NotificationApi from "../utils/api/notification/notification.api";
import FactureApi from "../utils/api/facture/facture.api";
import DisponibiliteApi from "../utils/api/disponibilite/disponibilite.api";
import AlertApi from "../utils/api/alert/alert.api";
import RdvApi from "../utils/api/rdv/rdv.api";
import VilleApi from "../utils/api/ville/ville.api";
import AppVersionApi from "../utils/api/appVersion/appVersion.api";


const store = configureStore({
  reducer: {
    [AuthApi.reducerPath]: AuthApi.reducer,
    [UserSlice.name]: UserSlice.reducer,
    [UserApi.reducerPath]: UserApi.reducer,
    [ConditionApi.reducerPath]: ConditionApi.reducer,
    [BlanchisserieApi.reducerPath]: BlanchisserieApi.reducer,
    [FaqApi.reducerPath]: FaqApi.reducer,
    [TutoApi.reducerPath]: TutoApi.reducer,
    [DesignationApi.reducerPath]: DesignationApi.reducer,
    [ProprietaireApi.reducerPath]: ProprietaireApi.reducer,
    [LogementApi.reducerPath]: LogementApi.reducer,
    [PromotionApi.reducerPath]: PromotionApi.reducer,
    [PrestataireApi.reducerPath]: PrestataireApi.reducer,
    [MessagerieApi.reducerPath]: MessagerieApi.reducer,
    [ParrainageApi.reducerPath]: ParrainageApi.reducer,
    [MissionApi.reducerPath]: MissionApi.reducer,
    [DashboardApi.reducerPath]: DashboardApi.reducer,
    [NotificationApi.reducerPath]: NotificationApi.reducer,
    [FactureApi.reducerPath]: FactureApi.reducer,
    [DisponibiliteApi.reducerPath]: DisponibiliteApi.reducer,
    [AlertApi.reducerPath]: AlertApi.reducer,
    [RdvApi.reducerPath]: RdvApi.reducer,
    [VilleApi.reducerPath]: VilleApi.reducer,
    [AppVersionApi.reducerPath]: AppVersionApi.reducer,
  },
  devTools: Env === currentEnv,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      AuthApi.middleware,
      UserApi.middleware,
      ConditionApi.middleware,
      BlanchisserieApi.middleware,
      FaqApi.middleware,
      TutoApi.middleware,
      DesignationApi.middleware,
      ProprietaireApi.middleware,
      LogementApi.middleware,
      PromotionApi.middleware,
      PrestataireApi.middleware,
      MessagerieApi.middleware,
      ParrainageApi.middleware,
      MissionApi.middleware,
      DashboardApi.middleware,
      NotificationApi.middleware,
      FactureApi.middleware,
      DisponibiliteApi.middleware,
      AlertApi.middleware,
      RdvApi.middleware,
      VilleApi.middleware,
      AppVersionApi.middleware,
    ),
});

export type AppDispatch = typeof store.dispatch;

export type RootState = ReturnType<typeof store.getState>;

export default store;
